import React from 'react';
import { defineMessages } from 'react-intl';
import { useCssHandles } from '../../../utils/functions';

import { useInstallments } from '../ProductInstallmentsList/hooks/useProductInstallmentsList';
import InstallmentsRenderer, { CSS_HANDLES } from './handles/InstallmentsRenderer';

const messages = defineMessages({
	title: {
		id: 'admin/installments-list-item.title',
	},
	titleMessage: {
		id: 'admin/installments.title',
	},
	description: {
		id: 'admin/installments.description',
	},
	default: {
		id: 'store/installments.default',
	},
});

interface Props {
	message?: string;
	markers?: string[];
	/** Used to override default CSS handles */
	blockClass?: any;
	componentId?: string;
}

function InstallmentsListItem({ message = messages.default.id, markers = [], blockClass, componentId }: Props) {
	const { handles, withModifiers } = useCssHandles(`vtex-product-price-1-x`, CSS_HANDLES, blockClass);
	const { installment } = useInstallments() ?? {};

	if (!installment) {
		return null;
	}
	const mkrs = getMarkers(markers);

	return (
		<InstallmentsRenderer
			componentId={componentId}
			message={message}
			blockClass={blockClass}
			markers={mkrs}
			installment={installment}
			handles={handles}
			handlesModifierFunction={withModifiers}
		/>
	);
}

function getMarkers(markers: any) {
	if (!markers || !markers.length) return [];
	if (Array.isArray(markers)) return markers;
	try {
		const mrk = JSON.parse(markers);
		return mrk;
	} catch (e) {
		const split = markers?.split(',');
		if (split?.length) return split;
		return [];
	}
}

InstallmentsListItem.schema = {
	title: 'admin/installments-list-item.title',
};

export default InstallmentsListItem;
